import React, { useRef, useState } from "react"
import * as HeaderStyles from "./Header.module.scss"
import BabyMenu from "./baby-menu/BabyMenu"
import MotherMenu from "./mother-menu/MotherMenu"

const { site } = require("../../../../utils/site")

const Header = ({
  siteData,
  sectorsData,
  jobAdsData,
  productCategoriesTree,
  gcProductCategoriesTree,
}) => {


  const isBrowser = typeof window !== "undefined"
  let queryTerm
  if (isBrowser) {
    const urlParams = new URLSearchParams(window?.location.search)
    console.log(urlParams)
    queryTerm = urlParams.get("q")
  }

  const [ismenuactive, setMenuActive] = useState(false)
  const [searchTerm, setSearchTerm] = useState(queryTerm)
  const updateMenuActive = (state) => {
    setMenuActive(state)
  }
  const updateSearchTerm = (term) => {
    setSearchTerm(term || "")
  }
  const header = useRef()
  return (
    <header
      ref={header}
      className={
        ismenuactive
          ? `${HeaderStyles.header} ${HeaderStyles.active}`
          : HeaderStyles.header
      }
    >
      {site !== "lp" && (
        <MotherMenu
          site={site}
          ismenuactive={ismenuactive}
          searchTerm={searchTerm}
          triggerParentUpdateSearchTerm={updateSearchTerm}
        />
      )}
      <BabyMenu
        site={site}
        siteData={siteData}
        sectorsData={sectorsData}
        jobAdsData={jobAdsData}
        productCategoriesTree={productCategoriesTree}
        gcProductCategoriesTree={gcProductCategoriesTree}
        ismenuactive={ismenuactive}
        triggerParentUpdate={updateMenuActive}
        searchTerm={searchTerm}
        triggerParentUpdateSearchTerm={updateSearchTerm}
      />
    </header>
  )
}

export default Header
